import type {
  ApiResponse,
  LaunchDayRow
} from '../../api-client';

import {
  apiRequest
} from './client';

export interface LaunchPurchasesRow extends LaunchDayRow {
  /** Paid, not refunded. */
  purchases: number
  /** Invoice totals, cents, ZAR. */
  grossCents: number
}

/** Admin: paid practice-pack purchases and gross per SAST day and campaign source. */
export async function getLaunchPurchases(
  token: string,
  options: { packKey?: string
    days?: number } = {}
): Promise<ApiResponse<{ packKey: string
  days: number
  currency: 'ZAR'
  rows: LaunchPurchasesRow[] }>> {

  const params = new URLSearchParams({
    packKey: options.packKey ?? 'maths-p1',
    days: String(options.days ?? 14)
  });

  return apiRequest(`/reports/launch-purchases?${ params.toString() }`, undefined, token);
}
